import type {
  AddEditClinicianRequestT,
  ClinicianIdentityProofingRequestT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { formatPhoneNumber } from '@/shared/lib/formatters';

import { toMdy } from './date-of-birth';
import { createEmptyDemographicInfo } from './demographic-info-schema';
import { LOTUS_OFFICE_DEFAULTS } from './lotus-office-defaults';
import { createEmptyClinicianInfo } from './prescriber-details-model';

type QaDosespotFixtureT = 'none' | 'arnold';

const QA_DOSESPOT_FIXTURE = (import.meta.env.VITE_QA_DOSESPOT_FIXTURE ?? 'none') as string;
const QA_DOSESPOT_PHONE_NUMBER = (import.meta.env.VITE_QA_DOSESPOT_PHONE_NUMBER ?? '') as string;

function env(key: string): string {
  return (import.meta.env[key] ?? '') as string;
}

function resolveQaFixture(): QaDosespotFixtureT {
  if (QA_DOSESPOT_FIXTURE === 'arnold') {
    return 'arnold';
  }
  return 'none';
}

export function isQaFixtureActive(): boolean {
  return resolveQaFixture() !== 'none';
}

function createArnoldDemographicFixture(): ClinicianIdentityProofingRequestT {
  return {
    FirstName: env('VITE_QA_ARNOLD_FIRST_NAME') || 'Arnold',
    LastName: env('VITE_QA_ARNOLD_LAST_NAME') || 'Bays',
    MiddleName: null,
    DateOfBirth: toMdy(env('VITE_QA_ARNOLD_DOB')),
    HomeAddress: env('VITE_QA_ARNOLD_ADDRESS') || '',
    City: env('VITE_QA_ARNOLD_CITY') || '',
    State: env('VITE_QA_ARNOLD_STATE') || '',
    ZipCode: env('VITE_QA_ARNOLD_ZIP') || '',
    PhoneNumber: formatPhoneNumber(QA_DOSESPOT_PHONE_NUMBER || '6282121990'),
    IsMobileNumber: true,
    SocialSecurityNumber: env('VITE_QA_ARNOLD_SSN'),
    CreditCardNumber: env('VITE_QA_ARNOLD_CC'),
    DrivingLicenseNumber: null,
    DrivingLicenseNumberState: null,
  };
}

function createArnoldPrescriberFixture(): AddEditClinicianRequestT {
  return {
    ...createEmptyClinicianInfo(),
    ...LOTUS_OFFICE_DEFAULTS,
    DateOfBirth: toMdy(env('VITE_QA_ARNOLD_DOB')),
    FirstName: env('VITE_QA_ARNOLD_FIRST_NAME') || 'Arnold',
    LastName: env('VITE_QA_ARNOLD_LAST_NAME') || 'Bays',
    NPINumber: '',
    ClinicianRoleType: ['1'],
  };
}

export function createQaDemographicInfoDefault(): ClinicianIdentityProofingRequestT {
  if (resolveQaFixture() === 'arnold') {
    return createArnoldDemographicFixture();
  }
  return createEmptyDemographicInfo();
}

export function createQaPrescriberInfoDefault(): AddEditClinicianRequestT {
  if (resolveQaFixture() === 'arnold') {
    return createArnoldPrescriberFixture();
  }
  return createEmptyClinicianInfo();
}
